import { TextField, TextFieldProps } from '@mui/material';

import React from 'react';

import styles from './TextField.module.scss';

const { border } = styles;

type CustomTextFieldProps = TextFieldProps & {
	name: string;
	type: string;
	fullWidth: boolean;
	label?: string | null;
	error?: boolean;
	helperText?: string | null;
	value: string | number;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	className?: string;
	inputProps?: any;
	dataTestId?: string;
	placeholder?: string;
};

const TextFieldComponent = (props: CustomTextFieldProps) => {
	const {
		name,
		type,
		label,
		error,
		helperText,
		value,
		onChange,
		onBlur,
		fullWidth,
		className,
		inputProps,
		dataTestId,
		placeholder,
	} = props;
	const defaultClass = `${styles['text-field-input']}`;
	const customClass = className ? `${defaultClass} ${className}` : defaultClass;
	return (
		<TextField
			className={customClass}
			size="small"
			fullWidth={fullWidth}
			name={name}
			type={type}
			label={label}
			error={!!error}
			helperText={error ? helperText : null}
			onChange={onChange}
			onBlur={onBlur}
			value={value}
			InputProps={inputProps}
			data-testid={dataTestId}
			placeholder={placeholder}
			sx={{
				'& .MuiOutlinedInput-root': {
					'& fieldset': {
						border: `1px solid ${border}`,
						borderRadius: '5px',
						top: '0px',
					},
					'&.Mui-focused fieldset': {
						border: `1px solid ${border}`,
						borderRadius: '5px',
						top: '0px',
					},
				},
			}}
		/>
	);
};

export default TextFieldComponent;
